import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';
import type { TSubscriptions } from 'api/types/subscription';

type IGetUserProps = UseQueryOptions<TSubscriptions, IRequestException>;

const fetchSubscribeOptions = async () => {
    const response = await apiClient.get('subscribe', {});
    return await response.json();
};

const fetchSubscriptions = async () => {
    const platform = localStorage.getItem('product_platform') ?? '';
    const response = await apiClient.get('subscriptions', {
        searchParams: { platform },
    });
    return await response.json();
};

export const useGetSubscriptions = ({ ...options }: IGetUserProps) => {
    return useQuery<TSubscriptions, IRequestException>(
        'subscription',
        async () => await fetchSubscriptions(),
        {
            ...options,
        }
    );
};

export const useGetSubscribeOptions = ({ ...options }: IGetUserProps) => {
    return useQuery<TSubscriptions, IRequestException>(
        'subscribe',
        async () => await fetchSubscribeOptions(),
        {
            ...options,
        }
    );
};
